import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { API } from '../../../../services/axios';
import { URLS } from '../../../../services/urls';
import CLoader from '../../../../components/Loader';

const ManageAgenciesForm = ({ toEdit, onSuccess, handleClose }) => {
  const [afterAction, setAfterAction] = useState('');
  const [loading, setLoading] = useState('');

  const { auth } = useSelector((state) => state.auth);

  const { active_agency } = useSelector((state) => state.agencies);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const onSubmit = (data) => {
    let toSend = {
      name: data.name,
      email: data.email,
      phone_number: data.phoneNumber,
      address: data.address,
      sigle: data.sigle,
      merchand_code_momo: data.merchand_code_momo,
      merchand_code_om: data.merchand_code_om,
    };
    

    if (toEdit) {
        setLoading(true);
      API.patch(URLS.AGENCIES.update((toEdit.id)), toSend)
        .then((resp) => {
          if (onSuccess) {
            onSuccess(resp.data);
          }
          toast.success('L\'agence a bien été modifié');
          setLoading(false);
          reset();
          if (handleClose) {
            handleClose();
          }
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.detail ??
            error?.response?.data ??
              "Une erreur s'est produite lors de l'ajout de l'agence, veuiller reésayer !"
          );
          setLoading(false);
        });
    } else {
      setLoading(true);
      API.post(URLS.AGENCIES.create, toSend)
        .then((resp) => {
          reset();
          if (onSuccess) {
            onSuccess(resp.data);
          }
          toast.success('L\'agence a bien été rajouté');
          setLoading(false);
          if (handleClose) {
            handleClose();
          }
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.detail ??
            error?.response?.data ??
              "Une erreur s'est produite lors de l'ajout de l'agence, veuiller reésayer !"
          );
          setLoading(false);
        });
    }
  };

  const handleSetAfterAction = (actionn) => {
    setAfterAction(actionn);

    window.$('#submitCustomerForm')?.click();
  };

  useEffect(() => {
    if(toEdit){
        reset({
            name: toEdit.name,
            email: toEdit.email,
            phoneNumber: toEdit.phone_number,
            address: toEdit.address,
            sigle: toEdit.sigle,
        })
    }
  }, [toEdit]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingFirstnameInput">Nom</label>
              <input
                type="text"
                className="form-control"
                id="floatingFirstnameInput"
                {...register('name')}
                placeholder="Nom"
              />
              {/* <div className="invalid-feedback">
                    Please select a valid state.
                </div> */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingLastnameInput">Adresse</label>
              <input
                type="text"
                className="form-control"
                id="floatingLastnameInput"
                {...register('address')}
                placeholder="Adresse"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingemailInput">Téléphone</label>
              <input
                type="tel"
                className="form-control"
                id="phoneNumber"
                {...register('phoneNumber')}
                placeholder="Téléphone"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingemailInput">Addresse email</label>
              <input
                type="email"
                className="form-control"
                id="floatingemailInput"
                {...register('email')}
                placeholder="Adresse email"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingSigleInput">Sigle</label>
              <input
                type="text"
                className="form-control"
                id="floatingSigleInput"
                {...register('sigle')}
                placeholder="ex: BAL"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingSigleInputOm">Code marchand OM</label>
              <input
                type="text"
                className="form-control"
                id="floatingSigleInputOm"
                {...register('merchand_code_om')}
                placeholder="ex: 000000"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingSigleInputmomo">Code marchand MOMO</label>
              <input
                type="text"
                className="form-control"
                id="floatingSigleInputmomo"
                {...register('merchand_code_momo')}
                placeholder="ex: 000000"
              />
            </div>
          </div>
        </div>
        
        <div className="button-items  d-inline-flex">
          <button hidden className="hidden" id="submitCustomerForm" type="submit"></button>
          <button
            type="button"
            onClick={() => handleSetAfterAction('CLOSE')}
            className="btn btn-primary w-md waves-effect waves-light d-flex"
          >
            <span className="my-auto">Soumettre</span>{' '}
            <span className="ms-2 d-inline-flex">
              {' '}
              <CLoader size={20} show={afterAction === 'CLOSE' && loading} />{' '}
            </span>
          </button>
          {/* <button
            type="button"
            onClick={() => handleSetAfterAction('DETAILS')}
            className="btn btn-primary w-md waves-effect waves-light d-flex"
          >
            <span className="my-auto">Soumettre et afficher les détails</span>{' '}
            <span className="ms-2 d-inline-flex">
              {' '}
              <CLoader size={20} show={afterAction === 'DETAILS' && loading} />{' '}
            </span>
          </button>
          <button
            type="button"
            onClick={() => handleSetAfterAction('ADD')}
            className="btn btn-primary w-md waves-effect waves-light d-flex"
          >
            <span className="my-auto">Soumettre et en ajouter un autre</span>{' '}
            <span className="ms-2 d-inline-flex">
              {' '}
              <CLoader size={20} show={afterAction === 'ADD' && loading} />{' '}
            </span>
          </button> */}
        </div>
      </form>
    </div>
  );
};

export default ManageAgenciesForm;
